import { useState, useEffect, useCallback } from 'react';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Checkbox,
  Radio,
  Row,
  Select,
  Tooltip,
  Upload,
  message,
} from 'antd';
import {
  fetchDieGroupDropdown,
  resetDieGroupList,
  resetCurrentGroupPage,
} from '../../slices/die-group';
import {
  fetchDieCategoryListDropdown,
  resetDieCategoryList,
  resetCurrentCategoryPage,
} from '../../slices/die-category';
import {
  fetchDieSubCategoryListDropdown,
  resetDieSubCategoryList,
  resetCurrentSubCategoryPage,
} from '../../slices/die-subcategory';
import {
  createDieProfile,
  deleteAutoCadDrawingDiagramImage,
  deleteCustomerApprovedDiagramImage,
  deleteDieDetailDiagramImage,
  deleteDieImage,
  deleteDieManuFacturingDiagramImage,
  deleteSopDetailDiagramImage,
  fetchDieProfilenumber,
  updateDieFile,
} from './../../slices/die-profile';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { PlusOutlined, EyeOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
const { Option } = Select;

export default function AddDieProfile() {
  const [form] = Form.useForm();
  const [formFile] = Form.useForm();

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = {
    die_type: 'Solid',
    balloon_drawing_dimensions: [
      {
        balloon_no: null,
        dim_type: "",
        nominal_value: null,
        tolerance_plus: null,
        tolerance_minus: null,
        min_value: null,
        max_value: null,
        description: "",
        is_inspection: false,
        is_critical: false,
        pos_x: null,
        pos_y: null
      },
    ],
  };
  const [selectedDieType, setSelectedDieType] = useState(
    initialValues.die_type,
  );
  const [btnLoading, setBtnLoading] = useState(false);
  const [profileExist, setProfileExist] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [searchSubCategory, setSearchSubCategory] = useState('');
  const [dieDiagramList, setDieDiagramList] = useState([]);
  const [uploadDiaDiagramError, setUploadDiaDiagramError] = useState('');
  const [detailFileList, setDetailFileList] = useState([]);
  const [uploadDieDetailsDiagramError, setUploadDieDetailsDiagramError] = useState('');
  const [uploadCustApprovedDieDiageamError, setUploadCustApprovedDieDiageamError] = useState('');
  const [uploadAutocadDrawingError, setUploadAutocadDrawingError] = useState('');
  const [uploadDieManufacturingError, setuploadDieManufacturingError] = useState('');
  const [sopFileList, setSopFileList] = useState([]);
  const [uploadSOPDiagramError, setUploadSOPDiagramError] = useState('');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedProfileCategory, setSelectedProfileCategory] = useState(null);
  const [selectedProfileSubCategory, setSelectedProfileSubCategory] = useState(null);
  const [
    customerApprovedDieDiagramFileList,
    setCustomerApprovedDieDiagramFileList,
  ] = useState([]);
  const [autoCadFileList, setAutoCadFileList] = useState([]);
  const [manufactureFileList, setManufactureFileList] = useState([]);
  const [profileResponse, setProfileResponse] = useState(null);
  const {
    list: dieGroupList,
    loading: groupLoading,
    currentpage: dieGroupCurrentPage,
    hasMore: dieGroupHasMore,
  } = useSelector(state => state.dieGroup);
  const {
    list: dieCategoryList,
    loading: categoryLoading,
    currentpage: categoryCurrentPage,
    hasMore: dieCategoryHasMore,
  } = useSelector(state => state.dieCategory);
  const {
    list: dieSubCategoryList,
    loading: subCategoryLoading,
    currentPage: subCategoryCurrentPage,
    hasMore: dieSubCategoryHasMore,
  } = useSelector(state => state.dieSubCategory);
  const getFileType = fileName => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'jpeg':
      case 'jpg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'dwg':
        return 'dwg';
      default:
        return false;
    }
  };
  const onScrollDieGroup = async event => {
    const target = event.target;
    if (
      !groupLoading &&
      dieGroupHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieGroupDropdown({ page: dieGroupCurrentPage, pagesize: 10 }),
      );
    }
  };

  const handleSearchProfileNumber = useCallback(
    debounce(value => {
      if (value) {
        dispatch(fetchDieProfilenumber({ die_number: value }))
          .unwrap()
          .then(response => {
            if (response.results.data.length === 0) {
              setProfileExist('');
            } else {
              setProfileExist('Profile Number Allready Exist');
            }
          })
          .catch(error => {
            console.error('Error fetching profile number:', error);
          });
      }
    }, 300),
    [dispatch],
  );

  const onScrollDieCategory = async event => {
    const target = event.target;
    if (
      !categoryLoading &&
      dieCategoryHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieCategoryListDropdown({ page: categoryCurrentPage, pagesize: 10 }),
      );
    }
  };

  const onScrollDieSubCategory = async event => {
    const target = event.target;
    if (
      !subCategoryLoading &&
      dieSubCategoryHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieSubCategoryListDropdown({
          page: subCategoryCurrentPage,
          pagesize: 1000,
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(resetDieGroupList());
    dispatch(resetDieCategoryList());
    dispatch(resetDieSubCategoryList());

    dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieCategoryListDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieSubCategoryListDropdown({ page: 1, pagesize: 1000 }));
  }, []);


  useEffect(() => {
    const items = form.getFieldValue("balloon_drawing_dimensions") || [];
    items.forEach((_, i) => {
      form.setFieldValue(
        ["balloon_drawing_dimensions", i, "balloon_no"],
        i + 1
      );
    });
  }, [form, form.getFieldValue("balloon_drawing_dimensions")?.length]);

  const handleChangeProfileGroup = value => {
    setSearchGroup(value);
    setSelectedGroup(value);
  };
  const getClassName = () => {
    const selected = dieGroupList.find(item => item.id === selectedGroup);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameProfileCategory = () => {
    const selected = dieCategoryList.find(
      item => item.id === selectedProfileCategory,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameProfileSubCategory = () => {
    const selected = dieSubCategoryList.find(
      item => item.id === selectedProfileSubCategory,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const handleChangeProfileCategory = value => {
    setSearchCategory(value);
    setSelectedProfileCategory(value);
  };

  const handleChangeProfileSubCategory = value => {
    setSearchSubCategory(value);
    setSelectedProfileSubCategory(value);
  };

  const handleSearchProfileGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 1000, search: value }));
      dispatch(resetDieGroupList());
    } else {
      dispatch(resetDieGroupList());
      dispatch(resetCurrentGroupPage());
      dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleSearchProfileCategory = value => {
    setSearchCategory(value);
    if (value) {
      setSearchCategory(value);
      dispatch(resetDieCategoryList());
      dispatch(
        fetchDieCategoryListDropdown({ page: 1, pagesize: 1000, search: value }),
      );
    } else {
      dispatch(resetDieCategoryList());
      dispatch(resetCurrentCategoryPage());
      dispatch(fetchDieCategoryListDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleSearchProfileSubCategory = value => {
    setSearchSubCategory(value);
    if (value) {
      setSearchSubCategory(value);
      dispatch(resetDieSubCategoryList());
      dispatch(
        fetchDieSubCategoryListDropdown({
          page: 1,
          pagesize: 1000,
          search: value,
        }),
      );
    } else {
      setSearchSubCategory('');
      dispatch(resetDieSubCategoryList());
      dispatch(resetCurrentSubCategoryPage());
      dispatch(fetchDieSubCategoryListDropdown({ page: 1, pagesize: 1000 }));
    }
  };
  const handleCurrentUploadFile = (value, filename) => {
    dispatch(
      updateDieFile({
        profileResponse,
        filename,
        value,
      }),
    )
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success(result?.message);
          if (result?.die_diagram) {
            setDieDiagramList(
              result.die_diagram
                ? [
                  {
                    name: result.die_diagram,
                    url: `${result.die_diagram}`,
                    type: getFileType(result.die_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.die_detail_diagram) {
            setDetailFileList(
              result.die_detail_diagram
                ? [
                  {
                    name: result.die_detail_diagram,
                    url: `${result.die_detail_diagram}`,
                    type: getFileType(result.die_detail_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.die_sop) {
            setSopFileList(
              result.die_sop
                ? [
                  {
                    name: result.die_sop,
                    url: `${result.die_sop}`,
                    type: getFileType(result.die_sop),
                  },
                ]
                : [],
            );
          }
          if (result?.customer_approved_diagram) {
            setCustomerApprovedDieDiagramFileList(
              result.customer_approved_diagram
                ? [
                  {
                    name: result.customer_approved_diagram,
                    url: `${result.customer_approved_diagram}`,
                    type: getFileType(result.customer_approved_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.autocad_drawing) {
            setAutoCadFileList(
              result.autocad_drawing
                ? [
                  {
                    name: result.autocad_drawing,
                    url: `${result.autocad_drawing}`,
                    type: getFileType(result.autocad_drawing),
                  },
                ]
                : [],
            );
          }
          if (result?.die_manufacturing) {
            setManufactureFileList(
              result.die_manufacturing
                ? [
                  {
                    name: result.die_manufacturing,
                    url: `${result.die_manufacturing}`,
                    type: getFileType(result.die_manufacturing),
                  },
                ]
                : [],
            );
          }
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const handleRemoveDieDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = profileResponse; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();
        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setDieDiagramList([]);
      }
      setDieDiagramList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveDieDetailDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = profileResponse; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieDetailDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setDetailFileList([]);
      }
      setDetailFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveSopDetailDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = profileResponse; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteSopDetailDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setSopFileList([]);
      }
      setSopFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };

  const handleRemoveCustomerApprovedDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url;
        const fileId = profileResponse;

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteCustomerApprovedDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setCustomerApprovedDieDiagramFileList([]);
      }
      setCustomerApprovedDieDiagramFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveAutoCadDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url;
        const fileId = profileResponse;

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteAutoCadDrawingDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setAutoCadFileList([]);
      }
      setAutoCadFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveDiemanufacturingDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url;
        const fileId = profileResponse;

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieManuFacturingDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setManufactureFileList([]);
      }
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };

  const handleFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadDiaDiagramError('File size must be smaller than 2MB!');
        setDieDiagramList(newFileList);
      } else {
        setUploadDiaDiagramError('');
        setDieDiagramList(newFileList);

        form.validateFields(['die_diagram']);
        handleCurrentUploadFile(fileList.originFileObj, 'die_diagram');
      }
    } else {
      setUploadDiaDiagramError('');
      setDieDiagramList([]);
    }
  };

  const validateFileList = () => {
    if (dieDiagramList.length === 0) {
      return Promise.reject(new Error('Please upload a file.'));
    }
    const fileType = dieDiagramList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    return Promise.resolve();
  };

  const handleDetailFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadDieDetailsDiagramError('File size must be smaller than 2MB!');
        setDetailFileList(newFileList);
      } else {
        setUploadDieDetailsDiagramError('');
        setDetailFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_detail_diagram');
      }
    } else {
      setUploadDieDetailsDiagramError('');
      setDetailFileList([]);
    }
  };
  const handleSopFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadSOPDiagramError('File size must be smaller than 2MB!');
        setSopFileList(newFileList);
      } else {
        setUploadSOPDiagramError('');
        setSopFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_sop');
      }
    } else {
      setUploadSOPDiagramError('');
      setSopFileList([]);
    }
  };
  const validateDetailFileList = () => {
    if (detailFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = detailFileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    const file = detailFileList[0];
    if (file.size / 1024 / 1024 > 2) {
      return Promise.reject(new Error('File size must be smaller than 2MB!'));
    }
    return Promise.resolve();
  };
  const validateSopFileList = () => {
    if (sopFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = sopFileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    const file = sopFileList[0];
    if (file.size / 1024 / 1024 > 2) {
      return Promise.reject(new Error('File size must be smaller than 2MB!'));
    }
    return Promise.resolve();
  };

  const handleCustomerApprovedDieDiagramFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];

    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadCustApprovedDieDiageamError(
          'File size must be smaller than 2MB!',
        );
        setCustomerApprovedDieDiagramFileList(newFileList);
      } else {
        setUploadCustApprovedDieDiageamError('');
        setCustomerApprovedDieDiagramFileList(newFileList);
        handleCurrentUploadFile(
          fileList.originFileObj,
          'customer_approved_diagram',
        );
      }
    } else {
      setUploadCustApprovedDieDiageamError('');
      setCustomerApprovedDieDiagramFileList([]);
    }
  };
  const validateCustomerApprovedFileList = () => {
    if (customerApprovedDieDiagramFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = customerApprovedDieDiagramFileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    const file = customerApprovedDieDiagramFileList[0];
    if (file.size / 1024 / 1024 > 2) {
      return Promise.reject(new Error('File size must be smaller than 2MB!'));
    }

    return Promise.resolve();
  };

  const handleAutoCadFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadAutocadDrawingError('File size must be smaller than 2MB!');
        setAutoCadFileList(newFileList);
      } else {
        setUploadAutocadDrawingError('');
        setAutoCadFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'autocad_drawing');
      }
    } else {
      setUploadAutocadDrawingError('');
      setAutoCadFileList([]);
    }
  };
  const validateAutoCadFileList = () => {
    if (autoCadFileList.length === 0) {
      return Promise.resolve();
    }
    const fileExtension = autoCadFileList[0]?.name
      .split('.')
      .pop()
      ?.toLowerCase();
    if (fileExtension !== 'dwg') {
      return Promise.reject(new Error('Only DWG files are allowed!'));
    }
    const file = autoCadFileList[0];
    if (file.size / 1024 / 1024 > 2) {
      return Promise.reject(new Error('File size must be smaller than 2MB!'));
    }
    return Promise.resolve();
  };

  const validateDieManufacturingFileList = () => {
    if (manufactureFileList.length === 0) {
      return Promise.resolve();
    }

    const fileExtension = manufactureFileList[0]?.name
      .split('.')
      .pop()
      ?.toLowerCase();
    if (fileExtension !== 'dwg') {
      return Promise.reject(new Error('Only DWG files are allowed!'));
    }
    const file = manufactureFileList[0];
    if (file.size / 1024 / 1024 > 2) {
      return Promise.reject(new Error('File size must be smaller than 2MB!'));
    }
    return Promise.resolve();
  };

  const handleDieManufactureFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setuploadDieManufacturingError('File size must be smaller than 2MB!');
        setManufactureFileList(newFileList);
      } else {
        setuploadDieManufacturingError('');
        setManufactureFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_manufacturing');
      }
    } else {
      setuploadDieManufacturingError('');
      setManufactureFileList([]);
    }
  };

  const handleFinish = values => {
    setBtnLoading(true);
    dispatch(
      createDieProfile({
        values,
      }),
    )
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          setProfileResponse(result?.data?.id);
          message.success('Profile Created Successfully!');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const onFinishFailed = errorInfo => { };

  const viewEntry = () => {
    navigate(`/view-dieprofile/${profileResponse}`);
  };
  const newEntryForm = () => {
    setProfileResponse(null);
    setDieDiagramList([]);
    setDetailFileList([]);
    setCustomerApprovedDieDiagramFileList([]);
    setAutoCadFileList([]);
    setManufactureFileList([]);
    setSopFileList([]);
    form.resetFields();
  };

  const handleDieTypeChange = e => {
    const value = e.target.value;
    setSelectedDieType(value);
    form.setFieldsValue({
      die_option: undefined,
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Add New Section</h2>
            <div className="bredcrumbwrp">
              <Link to="/die-profilelist" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-profilelist">Section</Link> },
                  { title: 'Add New Section' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          initialValues={initialValues}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="die_number"
                  label="Section Number"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a valid section number',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Section Number"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue =
                        value.charAt(0).toUpperCase() +
                        value.slice(1).toLowerCase();
                      form.setFieldsValue({ die_number: formattedValue });
                      handleSearchProfileNumber(formattedValue);
                    }}
                    maxLength={20}
                    allowClear
                  />
                </Form.Item>

                {profileExist && (
                  <p
                    style={{ color: '#ff4d4f', marginTop: '-25px' }}
                    className="ant-form-item-explain-error"
                  >
                    {profileExist}
                  </p>
                )}
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="customer_reference_number"
                  label="Customer Reference No"
                >
                  <Input
                    placeholder="Enter Customer Reference Number"
                    maxLength={25}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={5}>
                <Form.Item
                  name="description"
                  label="Description"
                >
                  <Input
                    placeholder="Enter description"
                    maxLength={25}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} xl={24} xxl={11}>
                <Row gutter={16}>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension1"
                      label="Dimension 1* (mm)"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter valid dimension 1',
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const regex = /^[0-9]*\.?[0-9]+$/;
                            if (regex.test(value) && parseFloat(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Dimension1 must be a positive number'),
                            );
                          },
                        },
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension2"
                      label="Dimension 2 (mm)"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const regex = /^[0-9]*\.?[0-9]+$/;
                            if (regex.test(value) && parseFloat(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Dimension1 must be a positive number'),
                            );
                          },
                        },
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension3"
                      label="Dimension 3 (mm)"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const regex = /^[0-9]*\.?[0-9]+$/;
                            if (regex.test(value) && parseFloat(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Dimension1 must be a positive number'),
                            );
                          },
                        },
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension4"
                      label="Dimension 4 (mm)"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const regex = /^[0-9]*\.?[0-9]+$/;
                            if (regex.test(value) && parseFloat(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Dimension1 must be a positive number'),
                            );
                          },
                        },
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="wt_kg_p_mt"
                  label="Calculated Kg/Mtr"
                  rules={[
                    {
                      required: true,
                      message: 'Enter valid calculated kg/mtr',
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }
                        const regex = /^[0-9]*\.?[0-9]+$/;
                        if (regex.test(value) && parseFloat(value) > 0) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'calculated kg/mtr must be a positive number',
                          ),
                        );
                      },
                    },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10,
                      maxAfterDecimal: 3,
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input
                    placeholder="Enter Calculated Kg/Mtr"
                    onChange={e => {
                      const value = e.target.value;
                      const num = parseFloat(value);
                      if (!isNaN(num)) {
                        const min = (num * 0.9).toFixed(3);
                        const max = (num * 1.1).toFixed(3);
                        form.setFieldsValue({
                          min_wt_kg_p_mt: min,
                          max_wt_kg_p_mt: max,
                        });
                      } else {
                        form.setFieldsValue({
                          min_wt_kg_p_mt: '',
                          max_wt_kg_p_mt: '',
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="min_wt_kg_p_mt"
                  label="Calculated negative kg/mtr"
                >
                  <Input placeholder="0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="max_wt_kg_p_mt"
                  label="Calculated positive kg/mtr"
                >
                  <Input placeholder="0" />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h5 className="rowsubtitle">Drawing Dimension Details</h5>
            <Form.List name="balloon_drawing_dimensions">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16} align="middle">
                          <Col xs={4} sm={2} xl={2}>
                            <Form.Item label="Balloon No." colon={false}>
                              <div style={{ marginTop: 8, fontWeight: 600 }}>
                                {index + 1}
                              </div>

                              <Form.Item
                                name={[name, "balloon_no"]}
                                initialValue={index + 1}
                                style={{ display: "none" }}
                              >
                                <Input type="hidden" />
                              </Form.Item>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'dim_type']}
                              label="Dimension Type"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter dim type',
                                },

                              ]}
                            >
                              <Input
                                placeholder="e.g. Outer Width"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'nominal_value']}
                              label="Nominal Value"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter nominal value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "nominal_value"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'tolerance_plus']}
                              label="+ Tolerance (mm)"
                              rules={[
                                {
                                  required: false,
                                  message: 'Please enter plus tolerance',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input placeholder="e.g. 1.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "tolerance_plus"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'tolerance_minus']}
                              label={`- Tolerance (mm)`}
                              rules={[
                                {
                                  required: false,
                                  message: 'Please enter minus tolerance',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input placeholder="e.g. 1.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "tolerance_minus"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'min_value']}
                              label="Min"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter min value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "min_value"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'max_value']}
                              label="Max"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter max value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "max_value"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'description']}
                              label="Description"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter description',
                                },

                              ]}
                            >
                              <Input
                                placeholder="e.g. Total outer profile width"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pos_x']}
                              label="X Position"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter nominal value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,2})?$/,
                                  message: "Enter a valid number (up to 2 decimals)",
                                },
                              ]}
                            >
                              <InputNumber style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "pos_x"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pos_y']}
                              label="Y Postiton"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter nominal value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,2})?$/,
                                  message: "Enter a valid number (up to 2 decimals)",
                                },
                              ]}
                            >
                              <InputNumber style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "pos_y"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={4} xxl={4}>

                            <Form.Item
                              {...restField}
                              name={[name, 'is_inspection']}
                              label="Inspection"
                              valuePropName="checked"
                            >
                              <Checkbox>
                                Inspection
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={4} xxl={4}>

                            <Form.Item
                              {...restField}
                              name={[name, 'is_critical']}
                              label="Critical"
                              valuePropName="checked"
                            >
                              <Checkbox>
                                Critical
                              </Checkbox>
                            </Form.Item>
                          </Col>

                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginTop: '0px',
                                }}
                              />
                            )}
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            add();
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Drawing Dimension Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>

          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="die_group"
                  label="Section Group"
                  rules={[
                    {
                      required: true,
                      message: 'Select valid section group',
                    },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Section Group"
                    loading={groupLoading}
                    onPopupScroll={onScrollDieGroup}
                    notFoundContent={groupLoading ? 'Loading...' : 'No options'}
                    value={searchGroup}
                    allowClear={false}
                    showSearch={true}
                    onSearch={handleSearchProfileGroup}
                    onChange={handleChangeProfileGroup}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    dropdownRender={menu => <>{menu}</>}
                    className={getClassName()}
                  >
                    {[
                      ...new Map(
                        dieGroupList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {groupLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="die_category"
                  label="Section Category"
                  rules={[
                    {
                      required: true,
                      message: 'Select valid section category',
                    },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Section Category"
                    loading={categoryLoading}
                    showSearch={true}
                    onPopupScroll={onScrollDieCategory}
                    value={searchCategory}
                    onChange={handleChangeProfileCategory}
                    onSearch={handleSearchProfileCategory}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={getClassNameProfileCategory()}
                    notFoundContent={
                      categoryLoading ? 'Loading...' : 'No options'
                    }
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {[
                      ...new Map(
                        dieCategoryList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {groupLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item name="die_sub_category" label="Section Subcategory">
                  <AutoOpenSelect
                    showSearch={true}
                    placeholder="Select Section Subcategory"
                    loading={subCategoryLoading}
                    onPopupScroll={onScrollDieSubCategory}
                    notFoundContent={
                      subCategoryLoading ? 'Loading...' : 'No options'
                    }
                    value={searchSubCategory}
                    onChange={handleChangeProfileSubCategory}
                    onSearch={handleSearchProfileSubCategory}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={getClassNameProfileSubCategory()}
                    allowClear
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {[
                      ...new Map(
                        dieSubCategoryList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {subCategoryLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={5}>
                <Form.Item
                  name="die_type"
                  label="Section Type"
                  rules={[
                    {
                      required: true,
                      message: 'Select a valid profile type',
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={handleDieTypeChange}
                    value={selectedDieType}
                    className="flex "
                  >
                    <Radio value="Hollow">Hollow</Radio>
                    <Radio value="Semi Hollow">Semi Hollow</Radio>
                    <Radio value="Solid">Solid</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="total_running_qty"
                  label="Total Running Kilometer"
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Kilometer" disabled />
                </Form.Item>
              </Col> */}
              {/* <Col xs={24} sm={12} xl={8} xxl={3}>
                <Form.Item
                  name="total_running_ton"
                  label="Total Running Qty"
                  colon={false}
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Metric Ton" disabled />
                </Form.Item>
              </Col> */}
            </Row>
          </div>

          <Form.Item name="remarks" label="Remarks">
            <Input.TextArea
              placeholder="Write a remark, maximum 150 characters"
              maxLength={150}
              onChange={e => {
                const value = e.target.value;
                const formattedValue = value
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase());
                form.setFieldsValue({ remarks: formattedValue });
              }}
            />
          </Form.Item>

          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Tooltip placement="top" title={'Add Profile'}>
                {profileResponse === null && (
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={btnLoading}
                    disabled={profileExist !== ''}
                    icon={<PlusOutlined />}
                  >
                    Add Section
                  </Button>
                )}
              </Tooltip>
            </Form.Item>
          </div>
        </Form>
        <Form
          className="pb-5"
          layout="vertical"
          form={formFile}
          autoComplete="off"
        >
          <small>
            <span style={{ color: '#ff4d4f', fontSize: '16px', fontWeight: 800 }}>
              *
            </span>
            All documents are saved on upload.
          </small>
          <div
            className="formsection uploadcardwrap"
            style={{ opacity: profileResponse !== null ? 1 : 0.3 }}
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="die_diagram"
                  label="Section Diagram"
                  valuePropName="dieDiagramList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.dieDiagramList
                  }
                  rules={[
                    {
                      validator: validateFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={dieDiagramList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".pdf,.jpeg,.jpg,.png"
                    maxCount={1}
                    onRemove={handleRemoveDieDiagramImage}
                    onChange={handleFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {dieDiagramList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadDiaDiagramError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadDiaDiagramError}
                  </div>
                )}
                <label className="filenote">
                  Upload PDF, JPEG, JPG or PNG file
                </label>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="die_detail_diagram"
                  label="Section Detail Diagram"
                  valuePropName="detailFileList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.detailFileList
                  }
                  rules={[
                    {
                      validator: validateDetailFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={detailFileList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".pdf"
                    maxCount={1}
                    onRemove={handleRemoveDieDetailDiagramImage}
                    onChange={handleDetailFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {detailFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadDieDetailsDiagramError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadDieDetailsDiagramError}
                  </div>
                )}
                <label className="filenote">Upload PDF file</label>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="customer_approved_diagram"
                  label="Customer Approved Die Diagram"
                  valuePropName="customerApprovedDieDiagramFileList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.customerApprovedDieDiagramFileList
                  }
                  rules={[
                    {
                      validator: validateCustomerApprovedFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={customerApprovedDieDiagramFileList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".pdf,.jpeg,.jpg,.png"
                    maxCount={1}
                    onRemove={handleRemoveCustomerApprovedDiagramImage}
                    onChange={handleCustomerApprovedDieDiagramFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {customerApprovedDieDiagramFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadCustApprovedDieDiageamError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadCustApprovedDieDiageamError}
                  </div>
                )}
                <label className="filenote">
                  Upload PDF, JPEG, JPG or PNG file
                </label>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="autocad_drawing"
                  label="Autocad Drawing"
                  valuePropName="autoCadFileList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.autoCadFileList
                  }
                  rules={[
                    {
                      validator: validateAutoCadFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={autoCadFileList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".dwg"
                    maxCount={1}
                    onRemove={handleRemoveAutoCadDiagramImage}
                    onChange={handleAutoCadFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {autoCadFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadAutocadDrawingError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadAutocadDrawingError}
                  </div>
                )}
                <label className="filenote">Upload DWG file</label>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="die_manufacturing"
                  label="Section Manufacturing"
                  valuePropName="manufactureFileList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.manufactureFileList
                  }
                  rules={[
                    {
                      validator: validateDieManufacturingFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={manufactureFileList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".dwg"
                    maxCount={1}
                    onRemove={handleRemoveDiemanufacturingDiagramImage}
                    onChange={handleDieManufactureFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {manufactureFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadDieManufacturingError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadDieManufacturingError}
                  </div>
                )}
                <label className="filenote">Upload DWG file</label>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="die_sop"
                  label="SOP"
                  valuePropName="sopFileList"
                  getValueFromEvent={e =>
                    Array.isArray(e) ? e : e && e.sopFileList
                  }
                  rules={[
                    {
                      validator: validateSopFileList,
                    },
                  ]}
                >
                  <Upload
                    fileList={sopFileList}
                    beforeUpload={() => false}
                    listType="picture"
                    accept=".pdf"
                    maxCount={1}
                    onRemove={handleRemoveSopDetailDiagramImage}
                    onChange={handleSopFileChange}
                    disabled={profileResponse === null}
                    showUploadList={{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                    }}
                  >
                    {sopFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div>Upload</div>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
                {uploadSOPDiagramError && (
                  <div style={{ color: 'red', marginTop: 5 }}>
                    {uploadSOPDiagramError}
                  </div>
                )}
                <label className="filenote">Upload PDF file</label>
              </Col>
            </Row>
          </div>
          <div className="row-buttons flex justify-end">
            {profileResponse !== null && (
              <>
                <Tooltip placement="top" title={'View Record'}>
                  <Button
                    type="primary"
                    style={{ marginRight: '15px' }}
                    htmlType="submit"
                    icon={<EyeOutlined />}
                    onClick={() => viewEntry()}
                  >
                    View Profile
                  </Button>
                </Tooltip>
                <Tooltip placement="top" title={'New Entry'}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<PlusOutlined />}
                    onClick={() => newEntryForm()}
                  >
                    New Entry
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
        </Form>
      </div>
    </>
  );
}
